import { makeObservable, observable, runInAction } from "mobx";
import {
	AuthRequest,
	LoginType,
	RoleType,
	TokenType,
	UserId,
	UserStatus,
} from "../../old/Types/Auth";
import registration from "../../old/Api/auth/Registration";
import login from "../../old/Api/auth/Login";
import stepPasswordApi, {
	StepPasswordApiProps,
} from "../../old/Api/newPassword/stepPassword";
import { URLHOSTADMIN } from "../../old/Const/envConst";
import { removeAllFromLocalStorage } from "../../old/Utils/removeAllfromLocalStorage";
import ProfileUserType from "../../old/Types/ProfileUserType";
import { ProfileStatus } from "../../old/Const/ProfileStatus";
import registrationCheckEmail from "../Api/auth/RegistrationCheckEmail";

class AuthStore {
	token: TokenType;

	forbidden: boolean;

	loginType: LoginType;

	userId: UserId;

	userStatus: UserStatus;

	name: string | undefined;

	surname: string | undefined;

	email: string | undefined;

	dataProfile?: ProfileUserType;

	profileChanged?: boolean;

	roles: RoleType[] | undefined;

	verified: boolean;

	constructor() {
		makeObservable(this, {
			token: observable,
			loginType: observable,
			userId: observable,
			userStatus: observable,
			name: observable,
			surname: observable,
			email: observable,
			forbidden: observable,
			dataProfile: observable,
			profileChanged: observable,
			roles: observable,
			verified: observable,
		});
		const token: TokenType = localStorage.getItem("token") || undefined;
		const userId: TokenType = localStorage.getItem("userId") || undefined;
		const userStatus: TokenType =
			localStorage.getItem("userStatus") || undefined;
		const loginType: TokenType = localStorage.getItem("loginType") || undefined;
		const name: string | undefined = localStorage.getItem("name") || undefined;
		const surname: string | undefined =
			localStorage.getItem("surname") || undefined;
		const email: string | undefined =
			localStorage.getItem("email") || undefined;
		const roles: RoleType[] =
			JSON.parse(localStorage.getItem("roles") || "[]") || undefined;
		if (token) {
			this.token = token;
			this.loginType = loginType;
			this.userId = userId;
			this.userStatus = userStatus;
			this.name = name;
			this.surname = surname;
			this.email = email;
			this.roles = roles;
		}
		this.forbidden = false;
		this.profileChanged = false;
		this.verified = false;
	}

	setBaseInfo = (
		token,
		loginType,
		userId,
		userStatus,
		name,
		surname,
		email
	) => {
		this.token = token;
		this.loginType = loginType;
		this.userId = userId;
		this.userStatus = userStatus;
		this.name = name;
		this.surname = surname;
		this.email = email;
	};

	logout = () => {
		removeAllFromLocalStorage("cookiesAccepted");
		runInAction(() => {
			this.token = undefined;
			this.userId = undefined;
			this.userStatus = undefined;
			this.loginType = undefined;
			this.name = undefined;
			this.surname = undefined;
			this.email = undefined;
		});
		new Promise<void>((res) => {
			res();
		}).then(() => {
			window.location.href = "/lk/auth";
		});
	};

	login = (dataRequest: AuthRequest) => {
		return login(dataRequest).then((data) => {
			const token = data.token;
			const userId = data.owner.id;
			const userStatus = data.owner.status;
			const loginType = data.loginType;
			const name = data.owner.firstname;
			const surname = data.owner.surname;
			const email = data.owner.email;
			const roles = data.owner.roles;
			if (
				token &&
				userId !== undefined &&
				userStatus !== undefined &&
				(loginType === 0 || loginType)
			) {
				runInAction(() => {
					this.token = token;
					this.name = name;
					this.surname = surname;
					this.email = email;
					this.roles = roles;
					localStorage.setItem("token", token);
					localStorage.setItem("userId", userId.toString());
					localStorage.setItem("userStatus", userStatus.toString());
					localStorage.setItem("loginType", loginType.toString());
					localStorage.setItem("roles", JSON.stringify(roles));
				});
				if (loginType === 1) {
					window.location.replace(URLHOSTADMIN);
				}
			}
			return data;
		});
	};

	registration = (dataRequest: AuthRequest) => {
		return registration(dataRequest).then((data) => {
			const token = data.token;
			const userId = data.owner.id;
			const userStatus = data.owner.status;
			const loginType = data.loginType;
			const email = data.owner.email;
			const roles = data.owner.roles;
			if (token) {
				runInAction(() => {
					this.token = token;
					localStorage.setItem("token", token);
					userId && localStorage.setItem("userId", userId.toString());
					roles && localStorage.setItem("roles", JSON.stringify(roles));
					userStatus &&
						localStorage.setItem("userStatus", userStatus.toString());
					loginType && localStorage.setItem("loginType", loginType.toString());
					email && localStorage.setItem("loginType", email.toString());
				});
			}
			return data;
		});
	};

	registrationCheckEmail = (email: string) => {
		return registrationCheckEmail(email).then((data) => {
			return data;
		});
	};

	newPassword = (dataRequest: StepPasswordApiProps) => {
		return stepPasswordApi(dataRequest).then((data) => {
			const token = data.token;
			if (token) {
				runInAction(() => {
					this.token = token;
					localStorage.setItem("token", token);
				});
			}
			return data;
		});
	};

	forbiddenSet = (e: boolean) => {
		runInAction(() => {
			this.forbidden = e;
		});
	};

	setProfile = (e: ProfileUserType | undefined) => {
		runInAction(() => {
			this.dataProfile = JSON.parse(JSON.stringify(e));
			this.verified = e?.status === ProfileStatus.VERIFIED;
		});
	};

	setProfileChanged = (value?: boolean) => {
		runInAction(() => {
			this.profileChanged = value ?? true;
		});
	};

	setUserInfo = ({
		email,
		surname,
		firstname,
	}: Pick<ProfileUserType, "firstname" | "surname" | "email">) =>
		runInAction(() => {
			this.name = firstname ?? "";
			this.surname = surname ?? "";
			this.email = email;
		});
}

export default new AuthStore();
